import React, { useContext } from 'react';
import { GoogleLogin } from 'react-google-login';
import { useStyletron } from 'baseui';
import { AppContext, UserContext, DASHBOARD } from 'commons-ui';

import config from 'config';

const InternalLogin: React.FC<{}> = () => {
	const { loginUser } = useContext(UserContext);
	const { showAlert } = useContext(AppContext);

	const [css] = useStyletron();

	const onSuccess = async (response: any) => {
		const { tokenObj, profileObj } = response;
		const err = await loginUser(tokenObj.id_token, tokenObj.access_token, profileObj, DASHBOARD.CRM);
		if (err) {
			showAlert('Please enter correct username and password', { type: 'error' });
		}
	};

	const onFailure = () => {
		showAlert('Error occured', { type: 'error' });
	};

	return (
		<GoogleLogin
			clientId={config.GCLIENT_ID}
			onSuccess={onSuccess}
			onFailure={onFailure}
			className={css({
				width: '200px',
				height: '70px',
				fontSize: '16px !important',
				color: 'black !important'
			})}
		/>
	);
};

export default InternalLogin;
